import React from 'react';
import {
	formatActivationCodeForDisplay,
	formatRequisitionNumberForDisplay
} from '../confirm/requisition-details/ActivationNumber';
import { cleanActivationCode } from '../util/gearOrderUtil';

const ClientActivationMissingMsg = ({ activationNumber }) => {
	const rawActivationCode = cleanActivationCode(activationNumber);

	let formattedNumber;
	if (rawActivationCode?.startsWith('C')) {
		formattedNumber = formatActivationCodeForDisplay(rawActivationCode);
	} else if (rawActivationCode) {
		formattedNumber = formatRequisitionNumberForDisplay(rawActivationCode);
	}

	let activationDetail = null;
	if (formattedNumber) {
		activationDetail = (
			<>
				,{' '}
				<strong>
					<span className="nowrap">{formattedNumber}</span>
				</strong>
				,
			</>
		);
	}

	return (
		<>
			<p>
				<strong>Collection Pack Activation Pending</strong>
			</p>
			<p>
				Your activation is on hold because we're still waiting for your doctor's test orders. Please share your
				activation number{activationDetail} with them and request the placement of the test order. Once it's
				complete, return to this page for next steps.
			</p>
		</>
	);
};

export default ClientActivationMissingMsg;
